// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--KNEUX"};